/// <amd-module name="Wiki/HeaderMetaData/HeaderMetaDataStore" />

import { Action } from "VSS/Reflux/Action";
import { Store } from "VSS/Reflux/Store";

import * as VC_Contracts from "Wiki/Clients/VC/Contracts/Git";
import { HeaderMetaDataFetchingPayload, IHeaderMetaDataState, IHeaderMetaDataStore } from "Wiki/HeaderMetaData/Interfaces/IHeaderMetadataTypes";
import { ActionListener } from "Wiki/ViewCommon/ActionListener";

export class HeaderMetaDataActions {
    public commitsDataFetched = new Action<VC_Contracts.GitCommitRef[]>();
    public linkedWitDataFetched = new Action<number[]>();
    public headerMetadataFetchingStarted = new Action<HeaderMetaDataFetchingPayload>();
    public clearPageMetadata = new Action<void>();
}

export function registerActionsWithStores(actionListener: ActionListener, actions: HeaderMetaDataActions, store: HeaderMetaDataStore): void {
    actionListener.addListener(actions.commitsDataFetched, store.onCommitsDataFetched);
    actionListener.addListener(actions.linkedWitDataFetched, store.onLinkedWorkItemsFetched);
    actionListener.addListener(actions.headerMetadataFetchingStarted, store.onHeaderMetadataFetchStart);
    actionListener.addListener(actions.clearPageMetadata, store.resetState);
}

export class HeaderMetaDataStore extends Store implements IHeaderMetaDataStore {
    private _state: IHeaderMetaDataState;

    constructor() {
        super("PageMetaDataStore");
        this._state = this._getInitialState();
    }

    public resetState = (): void => {
        this._state = this._getInitialState();
        this.emitChanged();
    };

    public onHeaderMetadataFetchStart = (headerMetaDataFetchingPayload: HeaderMetaDataFetchingPayload): void => {
        this._state = this._getInitialState();
        this._state.pagePath = headerMetaDataFetchingPayload.pagePath;
        this._state.gitItemPath = headerMetaDataFetchingPayload.gitItemPath;
        this.emitChanged();
    };

    public onCommitsDataFetched = (results: VC_Contracts.GitCommitRef[]): void => {
        if (results && results.length > 0) {
            const firstCommit = results[0];
            const push = firstCommit.push;
            this._state.pusher = push.pushedBy;
            this._state.pushDate = push.date;

            this.emitChanged();
        }
    };

    public onLinkedWorkItemsFetched = (workItemIds: number[]): void => {
        if (workItemIds) {
            this._state.workItemsCount = workItemIds.length;
            this.emitChanged();
        }
    };

    public onLinkedWorkItemsUpdated = (newCount: number): void => {
        if (newCount !== this._state.workItemsCount) {
            this._state.workItemsCount = newCount;
            this.emitChanged();
        }
    };

    public getState(): IHeaderMetaDataState {
        return this._state;
    }

    private _getInitialState = (): IHeaderMetaDataState => {
        return {
            workItemsCount: 0
        };
    };
}
